import { createCarritoSlice } from '../createCarritoSlice';

export const carritoMayoristaSlice = createCarritoSlice('carritoMayorista');

// Action creators are generated for each case reducer function
export const {
  agregarDatos,
  agregarProducto,
  quitarProducto,
  vaciarCarrito,
  reemplazarCarrito,
} = carritoMayoristaSlice.actions;

export default carritoMayoristaSlice.reducer;
